import React, { useContext } from "react";
import PropTypes from "prop-types";
import Confirmation from  "@cloudpremise/portal_core/src/themes/mui/components/Modals/Confirmation";
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from '@azure/msal-react';
import { DynamicObjectType, useDataProvider, callApi, leadAdapter, DataContext, Loader, DynamicObject } from "@cloudpremise/portal_core";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Box from '@mui/material/Box';
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDModal from "@cloudpremise/portal_core/src/themes/mui/components/MDModal";
import MDSelect from "@cloudpremise/portal_core/src/themes/mui/components/MDSelect";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDAvatar from "@cloudpremise/portal_core/src/themes/mui/components/MDAvatar/InitialAvatar";
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import FormWizard from "@cloudpremise/portal_core/src/themes/mui/components/FormWizard";

declare const window: Window & typeof globalThis & {
    inlineApexAdaptor: any,
    pdfjsLib: any,
    PDFViewerApplication: any,
    getViewerConfiguration: any,
    onRegistrationFormComplete: any,
    verifyEmailRegistrationAF: any,
    onLoginFormComplete: any,
    verifyEmailLoginAF: any
}

const DynamicObjectForm = (props) => {
    const { objectType, saveButtonText, Id } = props;
    const dataProvider = useContext(DataContext);
    let defaultState = {
        isSuccess: false,
        loading: false,
        errorMessage: null,

        Id: (Id ? Id : ''),
        formType: "form",
        form: [
            {
                heading: null,
                fields: [],
                conditionalStep: false,
                conditionalStepValue: null,
                conditionalField: null,
                conditionalFieldValue: [],
                conditionalSubField: null,
                conditionalSubFieldValue: null
            }
        ],
        openMenu: false,
        currentFormTab: 0,
        currentForm: null,
        dynamicObjectType: null,
        uploadingFiles: false,
        savingComment: false
    };
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    const dynamicObjectTypeRecord: DynamicObjectType = {
        sObjectTypeName: objectType,
        url: "/v1/dynamicobjecttype/"+objectType
    }
    const [loadingForm] = useDataProvider(dynamicObjectTypeRecord, {

    }, false, (data: any) => {
        if(data && Array.isArray(data?.result)){
            if(data.result.length > 0){
                let dynamicObjectType = data.result[0];
                let newState = {dynamicObjectType: dynamicObjectType};
                try{
                    let fields = [];
                    const schema = dynamicObjectType.schema;
                    for(let key in schema){
                        schema[key].fieldType = schema[key].fieldType.type.toUpperCase();
                        fields.push(schema[key]);
                    }
                    fields.sort(function(a, b){
                        return a.index - b.index
                    });
                    newState['form'] = [
                        {
                            heading: null,
                            fields: fields,
                            conditionalStep: false,
                            conditionalStepValue: null,
                            conditionalField: null,
                            conditionalFieldValue: [],
                            conditionalSubField: null,
                            conditionalSubFieldValue: null
                        }
                    ];
                }catch(e){ }
                setState(newState);
            }
        }
    });

    const dynamicObjectRecord: DynamicObject = {
        sObjectTypeName: objectType,
        url: "/v1/dynamicobject/"+Id
    }
    const [loadingObject] = useDataProvider(dynamicObjectRecord, {

    }, false, (data: any) => {
        if(data && Array.isArray(data?.result)){
            if(data.result.length > 0){
                let newState = {};
                try{
                    newState = data.result[0];
                }catch(e){ }
                setState(newState);
            }
        }
    });

    async function onSuccess(requestData, files){
        const { dynamicObjectType, Id } = state;
        let headers = {};
        let method = 'POST';
        let route = '/v1/dynamicobject/'+objectType;
        if(Id !== null && Id.length > 0){
            method = 'PATCH';
            route = '/v1/dynamicobject/'+Id;
        }

        const object: DynamicObject = {
            sObjectTypeName: objectType,
            url: route,
            method: method,
            headers: headers,
            data: {
                objectTypeName: objectType,
                objectTypeId: dynamicObjectType.dynamicObjectTypeId,
                data: requestData
            }
        };

        callApi(dataProvider, object).then(async (response: any) => {
            let result = response.result;
            if(Array.isArray(result)){
                result = result[0];
            }
            props.onSuccess(result);
        }).catch((err) => {
            let errorMessage = 'Unable to submit form.';
            if(err.hasOwnProperty("error") && err.error !== null){
                errorMessage = err.error;
            }
            setState({
                loading: false,
                error: true,
                errorMessage: errorMessage
            });
        });

        setState({
            loading: true,
            error: false,
            errorMessage: null
        });
    }
    return (
        <div>
            {
                loadingForm ?
                    <Loader color="info" />
                :
                <div>
                    {
                        state.dynamicObjectType !== null ?
                            <MDTypography variant="h4" mb={2}>
                                {state.dynamicObjectType.name}
                            </MDTypography>
                        :
                            null
                    }
                    <FormWizard
                        formBuilder={false}
                        formType={state.formType}
                        currentFormTab={state.currentFormTab}
                        form={state.form}
                        data={state}
                        item={state.item}
                        onFormChange={(form) => setState({form: form})}
                        onSuccess={(data, files) => onSuccess(data, files)}
                        onCancel={() => props.onCancel(state.item)}
                        saving={state.loading}
                        uploadingFiles={state.uploadingFiles}
                        disabled={false}
                        savingText={null}
                        buttons={null}
                        saveButtonText={saveButtonText}
                    />
                </div>
            }
            {
                state.error && state.errorMessage !== null ?
                    <Stack pt={2}>
                        <Alert severity="error">{state.errorMessage}</Alert>
                    </Stack>
                :
                    null
            }
        </div>
    )
};

DynamicObjectForm.defaultProps = {
    item: null,
    saveButtonText: "Submit Form"
}
DynamicObjectForm.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    onDelete: PropTypes.func,
    open: PropTypes.bool,
    item: PropTypes.object,
    objectType: PropTypes.string,
    saveButtonText: PropTypes.string,
    Id: PropTypes.string
};

export default DynamicObjectForm;